import React from "react";
import { Backdrop, CircularProgress, Typography, Box } from "@mui/material";

const ScreeningLoader = ({ open }) => (
  <Backdrop
    open={open}
    sx={{
      color: "#fff",
      zIndex: (theme) => theme.zIndex.modal + 1,
      flexDirection: "column",
      gap: 2,
    }}
  >
    <CircularProgress color="inherit" size={60} thickness={4} />
    <Box textAlign="center">
      <Typography variant="h6" fontWeight="bold">
        Performing Name Screen
      </Typography>
      <Typography variant="body2" sx={{ opacity: 0.85, mt: 0.5 }}>
        Saving data and running screening checks...
      </Typography>
    </Box>
  </Backdrop>
);

export default ScreeningLoader;
